import React, { useState, useEffect } from "react";
import "../../../styles/globalStyles.css";
import styles from "./Training.module.css";
import { ChessQueen, Binoculars } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import Seo from "./../../Seo";

export default function Training() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="/#"]');
      if (target && isMenuOpen) {
        closeMenu();
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, [isMenuOpen]);

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth"
        });
      }
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [location]);

  return (
    <>
      <Seo
        title="Szkolenia informatyczne i komputerowe"
        description="Prowadzimy szkolenia informatyczne dla osób prywatnych, firm i instytucji. Kursy komputerowe, szkolenia IT oraz zajęcia dla osób 50+ – stacjonarnie i online."
        canonical="/training"
      />
      <section id="service" className="sectionContainer light">
        <div className={`${styles.titleTraining} "sectionTitle"`}>
          <h1>Poznaj naszą ofertę szkoleń informatycznych</h1>
        </div>
        <div className={styles.list}>
          <div className={styles.listItem}>
            <span className={styles.iconNew}>
              <ChessQueen className={styles.iconNew} />
            </span>
            <span>
              Podczas naszych szkoleń najważniejsze jest dla nas bezpośrednie,
              ludzkie spotkanie. Dlatego standardowo realizujemy kursy w formie{" "}
              <strong>stacjonarnej</strong>. Jeśli uczestnik mieszka poza
              miejscem, w którym realizujemy szkolenia, istnieje również
              możliwość organizacji zajęć online za pomocą Google Meet, Zoom,
              Skype lub innego wybranego komunikatora.
            </span>
          </div>

          <div className={styles.listItem}>
            <span className={styles.iconNew}>
              <ChessQueen className={styles.iconNew} />
            </span>
            <span>
              Każdy uczestnik kursu, zarówno podczas szkolenia indywidualnego,
              jak i grupowego{" "}
              <strong>
                otrzymuje wsparcie trenera na każdym etapie realizacji kursu.
              </strong>
            </span>
          </div>

          <div className={styles.listItem}>
            <span className={styles.iconNew}>
              <ChessQueen className={styles.iconNew} />
            </span>
            <span>
              Zależy nam na rozwoju osób w każdym wieku. Z wielką radością
              zapraszamy na szkolenia także osoby{" "}
              <strong>powyżej 50. roku życia</strong>. Wierzymy, że zarówno
              młodzi, jak i seniorzy powinni mieć równy dostęp do wiedzy i
              narzędzi, które pozwalają swobodniej funkcjonować w cyfrowym
              świecie, korzystać z nowoczesnych narzędzi i rozwijać swoje
              umiejętności.
            </span>
          </div>

          <div className={styles.listItem}>
            <span className={styles.iconNew}>
              <ChessQueen className={styles.iconNew} />
            </span>
            <span>
              Jeżeli w naszej ofercie nie znajdą Państwo szkolenia dokładnie
              odpowiadającego Państwa potrzebom lub oczekiwanej tematyce –
              prosimy o kontakt. Chętnie porozmawiamy o tym, czego Państwo
              potrzebują i postaramy się przygotować rozwiązanie dopasowane do
              Państwa potrzeb.
            </span>
          </div>
        </div>
        <div className={styles.subtitle}>
          <h2>Poznaj nasze szkolenia</h2>
        </div>
        <div className={styles.serviceContent}>
          <Link
            to="/training/sql"
            onClick={closeMenu}
            className={styles.serviceItem}
          >
            <h3 className={styles.serviceTitle}>Podstawowy kurs SQL</h3>
            <div className={styles.container}>
              <div className={styles.additionInfoAboutCourse}>
                <p className={styles.forLevel}>
                  <strong className={styles.level}>Poziom:</strong>{" "}
                  <span>podstawowy</span>
                </p>
                <p className={styles.forWho}>
                  <strong className={styles.person}>Dla kogo:</strong>{" "}
                  <span>
                    Dla osób rozpoczynających naukę baz danych, studentów oraz
                    osób chcących zdobyć podstawowe umiejętności pracy z
                    językiem SQL i wykonywania zapytań do baz danych.
                  </span>
                </p>
              </div>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  Szkolenie wprowadza uczestników w świat języka SQL oraz
                  podstaw pracy z bazami danych. Podczas kursu poznasz
                  najważniejsze polecenia i techniki pozwalające na tworzenie
                  zapytań, wyszukiwanie oraz modyfikowanie danych. Zajęcia
                  prowadzone są od podstaw, dzięki czemu szkolenie jest
                  odpowiednie również dla osób rozpoczynających naukę SQL.
                </p>
              </div>
              <div className={styles.additionInfoAboutCourse}>
                <strong className={styles.forms}>Forma:</strong>{" "}
                <span>indywidulanie lub grupowe</span>
              </div>
              <div className={styles.iconContainer}>
                <Binoculars className={styles.icon} size={30} />
              </div>
            </div>
          </Link>

          <Link
            to="/training/cyfrowy-senior"
            onClick={closeMenu}
            className={styles.serviceItem}
          >
            <h3 className={styles.serviceTitle}>
              Szkolenie Z obsługi komputera dla osób 50+ <br />
              Cyfrowy senior
            </h3>
            <div className={styles.container}>
              <div className={styles.additionInfoAboutCourse}>
                <p className={styles.forLevel}>
                  <strong className={styles.level}>Poziom:</strong>{" "}
                  <span>podstawowy</span>
                </p>
                <p className={styles.forWho}>
                  <strong className={styles.person}>Dla kogo:</strong>{" "}
                  <span>
                    Dla osób, które chcą rozpocząć swoją przygodę z komputerem
                    lub uporządkować podstawowe umiejętności cyfrowe. W
                    szczególności dla osób 50+, które chcą nauczyć się
                    swobodnego i bezpiecznego korzystania z komputera oraz
                    internetu.
                  </span>
                </p>
              </div>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  Szkolenie z podstaw obsługi komputera zostało przygotowane z
                  myślą o osobach, które chcą w spokojnym tempie poznać
                  najważniejsze funkcje komputera i nauczyć się korzystania z
                  nowoczesnych technologii w codziennym życiu. Podczas zajęć
                  uczestnicy poznają podstawy obsługi systemu, pracy z plikami i
                  folderami, wyszukiwania informacji w internecie, korzystania z
                  poczty elektronicznej oraz zasady bezpiecznego poruszania się
                  w sieci. Szkolenie prowadzone jest w przyjaznej atmosferze, z
                  dużym naciskiem na praktyczne ćwiczenia oraz indywidualne
                  podejście do każdego uczestnika.
                </p>
              </div>
              <div className={styles.additionInfoAboutCourse}>
                <strong className={styles.forms}>Forma:</strong>{" "}
                <span>indywidulanie lub grupowe</span>
              </div>
              <div className={styles.iconContainer}>
                <Binoculars className={styles.icon} size={30} />
              </div>
            </div>
          </Link>

          {/* <div className={styles.serviceItem}>
          <h3 className={styles.serviceTitle}>Tworzenie stron WWW</h3>
          <div className={styles.container}>
            <div className={styles.textContainer}>
              <p className={styles.serviceDescribe}>
                Oferujemy kompleksowe szkolenie z tworzenia stron WWW, które
                pozwoli Ci zdobyć umiejętności niezbędne do projektowania i
                rozwijania nowoczesnych stron internetowych.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <Binoculars className={styles.icon} size={30} />
            </div>
          </div>
        </div> */}
          <div className={styles.serviceItem}>
            <h3 className={styles.serviceTitle}>Szkolenie UML</h3>
            <div className={styles.container}>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  {/* Nasz kurs UML to idealne rozwiązanie dla osób chcących nauczyć
                się modelowania systemów informatycznych. Oferujemy praktyczne
                podejście do nauki, które pozwoli Ci zrozumieć i stosować różne
                diagramy UML, takie jak diagramy klas, sekwencji czy przypadków
                użycia. Dzięki naszemu szkoleniu będziesz w stanie efektywnie
                projektować i dokumentować swoje projekty informatyczne. */}
                  <span>Kurs w przygotowaniu</span>
                </p>
              </div>
              <div className={styles.iconContainer}>
                <Binoculars className={styles.icon} size={30} />
              </div>
            </div>
          </div>
          <Link
            // to="/libreOfficeTraining"
            onClick={closeMenu}
            className={styles.serviceItem}
          >
            <h3 className={styles.serviceTitle}>
              Szkolenie z Pakietu LibreOffice
            </h3>
            <div className={styles.container}>
              <div className={styles.textContainer}>
                <p className={styles.serviceDescribe}>
                  {/* Nasz kurs LibreOffice to idealne rozwiązanie dla osób chcących
                nauczyć się efektywnie korzystać z tego darmowego pakietu
                biurowego. Oferujemy praktyczne podejście do nauki, które
                pozwoli Ci zrozumieć i stosować różne funkcje LibreOffice, takie
                jak edytor tekstu, arkusz kalkulacyjny czy program do tworzenia
                prezentacji. Dzięki naszemu szkoleniu będziesz w stanie
                efektywnie tworzyć i zarządzać dokumentami, arkuszami oraz
                prezentacjami, co pozwoli Ci zwiększyć swoją produktywność w
                pracy i codziennych zadaniach. */}
                  <span>Kurs w przygotowaniu</span>
                </p>
              </div>
              <div className={styles.iconContainer}>
                <Binoculars className={styles.icon} size={30} />
              </div>
            </div>
          </Link>
          {/* <div className={styles.serviceItem}>
          <h3 className={styles.serviceTitle}>Szkolenie CANVA</h3>
          <div className={styles.container}>
            <div className={styles.textContainer}>
              <p className={styles.serviceDescribe}>
                Oferujemy kompleksowe szkolenie z Canva, które pozwoli Ci
                tworzyć atrakcyjne grafiki i prezentacje w prosty sposób. Nasz
                kurs obejmuje zarówno podstawy, jak i zaawansowane techniki
                projektowania, dostosowane do różnych poziomów zaawansowania.
                Dzięki naszemu szkoleniu będziesz w stanie efektywnie korzystać
                z narzędzi Canva, tworzyć profesjonalne projekty graficzne i
                prezentacje, które wyróżnią się na tle konkurencji.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <Binoculars className={styles.icon} size={30} />
            </div>
          </div>
        </div> */}
          {/* <div className={styles.serviceItem}>
          <h3 className={styles.serviceTitle}>
            Szkolenie Z WYSZUKIWANIA INFORMACJI W SIECI
          </h3>
          <div className={styles.container}>
            <div className={styles.textContainer}>
              <p className={styles.serviceDescribe}>
                Oferujemy kompleksowe szkolenie z wyszukiwania informacji w
                sieci, które pozwoli Ci efektywnie poszukiwać i wykorzystywać
                dostępne zasoby internetowe. Nasz kurs obejmuje zarówno
                podstawy, jak i zaawansowane techniki wyszukiwania, dostosowane
                do różnych poziomów zaawansowania. Dzięki naszemu szkoleniu
                będziesz w stanie znaleźć potrzebne informacje w krótkim czasie
                i wykorzystać je w praktyce. W tym kursie nauczymy się jak
                korzystać ze sztucznej inteligenicji tj. ChatGPT, jak wyszukiwać
                informacje w Google, jak korzystać z baz danych i innych
                narzędzi, które pomogą Ci znaleźć potrzebne informacje w sieci.
              </p>
            </div>
            <div className={styles.iconContainer}>
              <Binoculars className={styles.icon} size={30} />
            </div>
          </div>
        </div>
      </div> */}
        </div>

        <div className="buttonSection">
          <div className="backButtonContainer">
            <button
              className="backButton"
              onClick={() => window.history.back()}
            >
              Powrót
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
